import React from 'react'
import '../css/NewCard.css'
import {
  AvatarGroup,
  Avatar as MuiAvatar,
  Tooltip
} from '@mui/material';
import Avatar, { genConfig } from 'react-nice-avatar';
import { stringAvatar } from '../../../utils/muiAvatar';

export default function NewCard({ project, model, handleMore, approved = true }) {

  return (
    <>
      {project ? (
        <div
          className={`card${approved ? '' : '-grey'}`}
          id={project.id}
          onClick={handleMore}
        >
          <div className="title">{project.title}</div>
          <div className="desc">{project.description}</div>
          <div className="info">
            <Tooltip title="Number of models" placement="top">
              <div className={`model-proj-num${approved ? '' : '-grey'}`}>{approved ? project.m2dModels.length : project.approveStatus}</div>
            </Tooltip>
            <Tooltip title={`Project owner${project.users.length > 1 ? "s" : ""}`} placement="top">
              <div className={`users${approved ? '' : '-grey'}`}>
                <AvatarGroup max={2}>
                  {project.users.map((user) => {
                    return user.avatar ? (
                      <MuiAvatar key={user.id}><Avatar style={{ width: '29px', height: '29px' }} {...genConfig(JSON.parse(user.avatar))} /></MuiAvatar>
                    ) : (
                      <MuiAvatar {...stringAvatar(`${user.firstName} ${user.lastName}`, {}, approved)} key={user.id} />
                    )
                  })}
                </AvatarGroup>
              </div>
            </Tooltip>
          </div>
        </div>
      ) : null}

      {model ? (
        <div
          className={`card${approved ? '' : '-grey'}`}
          id={model.Id}
          onClick={handleMore}
        >
          <div className="title">{model.name}</div>
          <div className="desc">{model.details}</div>
          <div className="info">
            <Tooltip title="Number of projects" placement="top">
              <div className={`model-proj-num${approved ? '' : '-grey'}`}>{approved ? model.m2dProjects.length : model.approveStatus}</div>
            </Tooltip>
            {model.m2dModelStars ? (
              <div className="model-proj-star">
                {model?.m2dModelStars?.length} star{model?.m2dModelStars?.length > 1 ? "s" : ""}
              </div>
            ) : null}
            <Tooltip title={`Model owner${model.users.length > 1 ? "s" : ""}`} placement="top">
              <div className="users">
                <AvatarGroup max={2}>
                  {model.users.map((user) => {
                    return user.avatar ? (
                      <MuiAvatar key={user.id}><Avatar style={{ width: '29px', height: '29px' }} {...genConfig(JSON.parse(user.avatar))} /></MuiAvatar>
                    ) : (
                      <MuiAvatar {...stringAvatar(`${user.firstName} ${user.lastName}`)} key={user.id} />
                    )
                  })}
                </AvatarGroup>
              </div>
            </Tooltip>
          </div>
        </div>
      ) : null}
    </>
  )
}
